import script from "./ColisErrones.vue?vue&type=script&setup=true&lang=js"
export * from "./ColisErrones.vue?vue&type=script&setup=true&lang=js"

import "./ColisErrones.vue?vue&type=style&index=0&id=6bb2beab&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6bb2beab"]])

export default __exports__